export default "__VITE_ASSET__BAK7psZI__"